import React, { useState, useEffect } from 'react';
import { HiMenuAlt4, HiX } from 'react-icons/hi';
import { motion } from 'framer-motion';
import { Link } from "react-router-dom";
import { images } from '../../constants';
import './Navbar.scss';

const Navbar = () => {
  const [toggle, setToggle] = useState(false);
  const [bgColor, setBgColor] = useState("transparent");

  useEffect(() => {
    const handleScroll = () => {
      setBgColor(window.scrollY > 0 ? "#f5f4f1" : "transparent");
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <nav className="app__navbar" style={{ backgroundColor: bgColor }}>
      <div className="app__navbar-logo">
        <img src={images.logo} alt="logo" />
      </div>

      {/* DESKTOP MENU */}
      <ul className="app__navbar-links">
        <li className="app__flex p-text">
          <div />
          <Link to="/">home</Link>
        </li>

        <li className="app__flex p-text">
          <div />
          <Link to="/about">about</Link>
        </li>
        <li className="app__flex p-text">
          <div />
          <Link to="/projects">projects</Link>
        </li>

        <li className="app__flex p-text">
          <div />
          <Link to="/services">service</Link>
        </li>

        {/* 🔽 PORTFOLIO DROPDOWN */}
        <li className="app__flex p-text app__navbar-dropdown">
          <div />
          <span className='nav-text'>portfolio</span>

          <ul className="dropdown-menu">
            <li><Link to="/portfolio/exterior">Architecture</Link></li>
            <li><Link to="/portfolio/interior">Interior</Link></li>
            <li><Link to="/portfolio/revit-bim">Revit BIM</Link></li>
          </ul>
        </li>

        <li className="app__flex p-text">
          <div />
          <Link to="/testimonials">testimonials</Link>
        </li>

        <li className="app__flex p-text">
          <div />
          <Link to="/faqs">faqs</Link>
        </li>

        <li className="app__flex p-text">
          <div />
          <Link to="/contact">contact</Link>
        </li>
      </ul>

      {/* MOBILE MENU */}
      <div className="app__navbar-menu">
        <HiMenuAlt4 onClick={() => setToggle(true)} />

        {toggle && (
          <motion.div
            whileInView={{ x: [300, 0] }}
            transition={{ duration: 0.85, ease: 'easeOut' }}
          >
            <HiX onClick={() => setToggle(false)} />

            <ul>
              <li><Link to="/" onClick={() => setToggle(false)}>home</Link></li>
              <li><Link to="/about" onClick={() => setToggle(false)}>about</Link></li>
              <li><Link to="/services" onClick={() => setToggle(false)}>services</Link></li>
              <li><Link to="/projects" onClick={() => setToggle(false)}>projects</Link></li>


              {/* MOBILE PORTFOLIO */}
              <li className="mobile-portfolio">
                <span>portfolio</span>
                <ul className="mobile-submenu">
                  <li><Link to="/portfolio/interior" onClick={() => setToggle(false)}>Interior</Link></li>
                  <li><Link to="/portfolio/exterior" onClick={() => setToggle(false)}>Exterior</Link></li>
                  <li><Link to="/portfolio/revit-bim" onClick={() => setToggle(false)}>Revit BIM</Link></li>
                </ul>
              </li>

              <li><Link to="/contact" onClick={() => setToggle(false)}>contact</Link></li>
            </ul>
          </motion.div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
